import { NavLink } from 'react-router-dom';
import { Home, Package, FileText, Users, CreditCard, Star, ClipboardList, Settings } from 'lucide-react';
import TruckLogo from '../../../assets/images/Truck-Logo.png';

const navItems = [
  { label: 'Dashboard', path: '/app/dashboard', icon: <Home className="w-5 h-5" /> },
  { label: 'Loads', path: '/app/loads', icon: <Package className="w-5 h-5" /> },
  { label: 'Documents', path: '/app/documents', icon: <FileText className="w-5 h-5" /> },
  { label: 'Drivers & Vehicles', path: '/app/drivers-and-vehicles', icon: <Users className="w-5 h-5" /> },
  { label: 'Billing', path: '/app/billing', icon: <CreditCard className="w-5 h-5" /> },
  { label: 'Feedback', path: '/app/feedback', icon: <Star className="w-5 h-5" /> },
  { label: 'Audit Logs', path: '/app/audit-logs', icon: <ClipboardList className="w-5 h-5" /> },
  { label: 'Settings', path: '/app/system-settings', icon: <Settings className="w-5 h-5" /> },
];

export function Sidebar() {
  return (
    <aside className="w-64 bg-white border-r border-gray-200 flex flex-col">
      {/* Logo */}
      <div className="flex items-center justify-between px-6 py-4 border-b border-gray-200">
        <div className="flex items-center gap-2">
          <img src={TruckLogo} alt="Load App Logo" className="w-14 h-14" />
          <div className="flex flex-col">
            <span className="font-semibold text-gray-800">TruckFlow</span>
            <span className="text-xs text-gray-500">Logistics management</span>
          </div>
        </div>
      </div>

      {/* Navigation */}
      <nav className="flex-1 px-2 py-4 space-y-1">
        {navItems.map((item) => (
          <NavLink key={item.path} to={item.path} className={({ isActive }) => `flex items-center gap-3 px-4 py-2 rounded-lg text-sm font-medium transition ${isActive ? 'bg-blue-50 text-blue-600' : 'text-gray-700 hover:bg-gray-100'}`}>
            {item.icon}
            <span>{item.label}</span>
          </NavLink>
        ))}
      </nav>
    </aside>
  );
}
